import React, { FunctionComponent, useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import {
  DetalhesCabecalho,
  DetalhesMotorista,
  DetalhesVeiculo,
  HorizontalLine,
  Label,
  SideBar,
  Subtitle,
  Title,
  Value,
} from './styles'
import { MdClose, MdLocalShipping, MdPerson } from 'react-icons/md'
import ILoteSolicitado from 'modules/lotesSolicitados/domain/entities/LoteSolicitado'
import { cpfMask, numberToCurrency } from 'shared/utils/formatters'
import { colors } from 'shared/styles/colors'
import DocumentosAnexados from './DocumentosAnexados'
import IGetDocumentosImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentosImpl'
import { IDocumentoResponse } from 'modules/lotesSolicitados/domain/entities/IDocumentoResponse'
import { ETipoDocumento } from 'modules/lotesSolicitados/domain/entities/ETipoDocumento'
import SnackBar from 'shared/components/SnackBar'
import IGetAllDocumentosPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetAllDocumentosPdfImpl'
import IGetDocumentoPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentoPdfImpl'
import IGetDocumentoPedagioPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentoPedagioPdfImpl'

interface IProps {
  setOpenDrawer: (value: boolean) => void
  lote: ILoteSolicitado
  getDocumentos: IGetDocumentosImpl
  getAllDocumentosPdf: IGetAllDocumentosPdfImpl
  getDocumentoPdf: IGetDocumentoPdfImpl
  getDocumentoPedagioPdf: IGetDocumentoPedagioPdfImpl
}

const Drawer: FunctionComponent<IProps> = ({
  setOpenDrawer,
  lote,
  getDocumentos,
  getAllDocumentosPdf,
  getDocumentoPdf,
  getDocumentoPedagioPdf,
}) => {
  const [openSnack, setOpenSnack] = useState(false)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [documentos, setDocumentos] = useState<IDocumentoResponse[]>()
  const [total, setTotal] = useState(0)
  const [cte, setCte] = useState<string[]>()
  const [cfe, setCfe] = useState<string[]>()
  const [mdfe, setMdfe] = useState<string[]>()
  const [termoEstadia, setTermoEstadia] = useState<string[]>()
  const [cartaFrete, setCartaFrete] = useState<string[]>()
  const [contratoFrete, setContratoFrete] = useState<string[]>()
  const [reciboPedagio, setReciboPedagio] = useState<string[]>()

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      try {
        const response = await getDocumentos.execute(lote.tmov_lote_conjunto_id)
        let ctes = []
        let cfes = []
        let mdfes = []
        let termosEstadia = []
        let cartasFrete = []
        let contratoFrete = []
        let recibosPedagio = []

        const documentosSemOC = response?.filter(
          doc => doc.titulo !== ETipoDocumento.ORDEMCARREGAMENTO,
        )

        if (response && response.length > 0) {
          documentosSemOC.forEach(documento => {
            switch (documento.titulo) {
              case ETipoDocumento.CTE:
                ctes = documento.links
                break
              case ETipoDocumento.CFE:
                cfes = documento.links
                break
              case ETipoDocumento.MDFE:
                mdfes = documento.links
                break
              case ETipoDocumento.TERMOSESTADIA:
                termosEstadia = documento.links
                break
              case ETipoDocumento.CARTAFRETE:
                cartasFrete = documento.links
                break
              case ETipoDocumento.CONTRATOFRETE:
                contratoFrete = documento.links
                break
              case ETipoDocumento.RECIBOPEDAGIO:
                recibosPedagio = documento.links
                break
              default:
                break
            }
          })

          setCte(ctes)
          setCfe(cfes)
          setMdfe(mdfes)
          setTermoEstadia(termosEstadia)
          setCartaFrete(cartasFrete)
          setContratoFrete(contratoFrete)
          setReciboPedagio(recibosPedagio)
          setTotal(
            ctes.length +
              cfes.length +
              mdfes.length +
              termosEstadia.length +
              cartasFrete.length +
              contratoFrete.length +
              recibosPedagio.length,
          )
        }
        setDocumentos(documentosSemOC)
      } catch (error: any) {
        setOpenSnack(true)
        setMessage(error.message)
      } finally {
        setLoading(false)
      }
    }
    init()
  }, [getDocumentos, lote.tmov_lote_conjunto_id])

  return (
    <SideBar>
      <DetalhesCabecalho>
        <Grid container md={12} xs={8}>
          <Grid item md={6}>
            <Title>Detalhes da viagem</Title>
          </Grid>

          <Grid container md={5} spacing={1}>
            <Grid item md={4}>
              <Value>Código:</Value>
            </Grid>
            <Grid item md={8}>
              <Value>{lote.id}</Value>
            </Grid>
          </Grid>

          <Grid item md={1}>
            <Grid container>
              <div
                onClick={() => setOpenDrawer(false)}
                style={{ cursor: 'pointer' }}
              >
                <MdClose />
              </div>
            </Grid>
          </Grid>
        </Grid>

        <div style={{ height: 30 }}></div>

        <Grid container md={12} xs={8} spacing={2}>
          <Grid item md={6}>
            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Origem:</Label>
              </Grid>
              <Grid item md={8}>
                <Value>{lote.origem}</Value>
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Preço:</Label>
              </Grid>
              <Grid item md={8}>
                <Value>{numberToCurrency(lote.valor)}</Value>
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Filial:</Label>
              </Grid>
              <Grid item md={8}>
                <Value>{lote.filial}</Value>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={6}>
            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Destino:</Label>
              </Grid>
              <Grid item md={7}>
                {lote.destino}
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Produto:</Label>
              </Grid>
              <Grid item md={7}>
                {lote.produto}
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Pedágio:</Label>
              </Grid>
              <Grid item md={7}>
                {numberToCurrency(lote.total_pedagio)}
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={12}></Grid>
        </Grid>
      </DetalhesCabecalho>
      <DetalhesMotorista>
        <Grid container md={12} xs={8}>
          <Grid item md={12}>
            <MdPerson color="#24A95D" style={{ marginRight: 10 }} />
            <Subtitle>Motorista</Subtitle>
          </Grid>
        </Grid>

        <div style={{ height: 30 }}></div>

        <Grid container md={12} xs={8}>
          <Grid item md={11}>
            <Grid container spacing={4}>
              <Grid item md={2}>
                <Label>Nome:</Label>
              </Grid>
              <Grid item md={10}>
                <Value>{lote.conjunto.motorista.nome}</Value>
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={2}>
                <Label>CNH:</Label>
              </Grid>
              <Grid item md={10}>
                <Value>{lote.conjunto.motorista.cnh}</Value>
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={2}>
                <Label>CPF:</Label>
              </Grid>
              <Grid item md={10}>
                <Value>{cpfMask(lote.conjunto.motorista.cpf)}</Value>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DetalhesMotorista>
      <HorizontalLine></HorizontalLine>
      <DetalhesVeiculo>
        <Grid container md={12} xs={8}>
          <Grid item md={12}>
            <MdLocalShipping color={colors.green} style={{ marginRight: 10 }} />
            <Subtitle>Veículo</Subtitle>
          </Grid>
        </Grid>

        <div style={{ height: 30 }}></div>

        <Grid container md={12} spacing={1}>
          <Grid item md={6}>
            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Modelo:</Label>
              </Grid>
              <Grid item md={8}>
                <Value>{lote.conjunto.caminhao.tipoCaminhao.descricao}</Value>
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Cavalo:</Label>
              </Grid>
              <Grid item md={8}>
                <Value>{lote.conjunto.caminhao.veiculoCavalo.placa}</Value>
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>2ª Carreta:</Label>
              </Grid>
              <Grid item md={8}>
                <Value>{lote.conjunto.caminhao.veiculoCarreta2?.placa}</Value>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={6}>
            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>Conjunto:</Label>
              </Grid>
              <Grid item md={7}>
                {lote.conjunto.caminhao.descricao}
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>1ª Carreta:</Label>
              </Grid>
              <Grid item md={7}>
                {lote.conjunto.caminhao.veiculoCarreta1?.placa}
              </Grid>
            </Grid>

            <Grid container spacing={4}>
              <Grid item md={4}>
                <Label>3ª Carreta:</Label>
              </Grid>
              <Grid item md={7}>
                {lote.conjunto.caminhao.veiculoCarreta3?.placa}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DetalhesVeiculo>
      <HorizontalLine></HorizontalLine>
      <DocumentosAnexados
        lote={lote}
        loading={loading}
        setLoading={setLoading}
        CTE={cte}
        CFE={cfe}
        MDFE={mdfe}
        CartaFrete={cartaFrete}
        ContratoFrete={contratoFrete}
        TermoEstadia={termoEstadia}
        ReciboPedagio={reciboPedagio}
        total={total}
        getAllDocumentosPdf={getAllDocumentosPdf}
        getDocumentoPdf={getDocumentoPdf}
        getDocumentoPedagioPdf={getDocumentoPedagioPdf}
      />
      <SnackBar
        open={openSnack}
        message={message}
        setOpen={setOpenSnack}
        severity={'error'}
      />
    </SideBar>
  )
}

export default Drawer
